"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
function logError(err) {
    console.error('An Event-Object must be passed to handleChange, handleBlur and handleSubmit', [err]);
}
function getUsefulEventData(e) {
    try {
        var _a = e.target, type = _a.type, checked = _a.checked, value = _a.value;
        return {
            name: e.target.name,
            value: type === 'checkbox' ? checked : value,
        };
    }
    catch (err) {
        logError(err);
    }
}
var useForm = function (initialValues, validate) {
    if (initialValues === void 0) { initialValues = {}; }
    var _a = react_1.useState(initialValues), commitedValues = _a[0], setCommitedValues = _a[1];
    var _b = react_1.useState({}), errorMap = _b[0], setErrorMap = _b[1];
    var _c = react_1.useState(false), isDirty = _c[0], setIsDirty = _c[1];
    var _d = react_1.useState(false), isSubmitting = _d[0], setIsSubmitting = _d[1];
    var _e = react_1.useState(false), isValid = _e[0], setIsValid = _e[1];
    var _f = react_1.useState({}), touchedMap = _f[0], setTouchedMap = _f[1];
    var _g = react_1.useState(initialValues), values = _g[0], setValues = _g[1];
    var calculate = function () {
        var errors = typeof validate === 'function' ? validate(values) : {};
        setErrorMap(errors);
        setIsDirty(JSON.stringify(commitedValues) !== JSON.stringify(values));
        setIsValid(!Object.keys(errors).find(function (key) { return errors[key]; }));
    };
    react_1.useEffect(calculate, [commitedValues, values, validate]);
    /**
     * @param {object} values => key/value pairs
     */
    function commit(values) {
        setCommitedValues(values);
        setValues(values);
        setTouchedMap({});
    }
    // Restores to the last commited point
    function rollBack() {
        commit(commitedValues);
    }
    /**
     * @param {string} name => Represents the field name
     * @param {*} value => Field value
     */
    function setValue(name, value) {
        var _a;
        setValues(__assign(__assign({}, values), (_a = {}, _a[name] = value, _a)));
    }
    /**
     * @param {string} name => Represents the field name
     */
    function setFieldTouched(name) {
        var _a;
        setTouchedMap(__assign(__assign({}, touchedMap), (_a = {}, _a[name] = true, _a)));
    }
    function handleChange(e) {
        var _a = getUsefulEventData(e), name = _a.name, value = _a.value;
        setValue(name, value);
    }
    function handleBlur(e) {
        var name = getUsefulEventData(e).name;
        setFieldTouched(name);
    }
    /**
     * @param {function} callback => Normal/Async function that will be passed with the "values"
     */
    function handleSubmit(callback) {
        var _this = this;
        return function (e) { return __awaiter(_this, void 0, void 0, function () {
            var err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        e.preventDefault();
                        setIsSubmitting(true);
                        return [4 /*yield*/, callback(values)];
                    case 1:
                        _a.sent();
                        setIsSubmitting(false);
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        logError(err_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
    }
    return {
        commit: commit,
        errorMap: errorMap,
        handleBlur: handleBlur,
        handleChange: handleChange,
        handleSubmit: handleSubmit,
        isDirty: isDirty,
        isSubmitting: isSubmitting,
        isValid: isValid,
        rollBack: rollBack,
        setFieldTouched: setFieldTouched,
        setValue: setValue,
        touchedMap: touchedMap,
        values: Object.freeze(values),
    };
};
exports.default = useForm;
